import React from "react";

const Pogoji = () => {
  return (
    <div>
      <div className='pogoji-container'>
        <h1>Pogoji uporabe spletne strani</h1>
        <h2>Sprejem pogojev</h2>
        <p>
          Uporabnik je zavezan upoštevati dane pogoje, ki so navedene na tej
          strani.
        </p>
        <p>
          Spletno mesto predstavlja vsaka stran v okviru naslova
          www.anglescina-bic.web.app
        </p>
        <h2>Uporaba podatkov in varovanje osebnosti</h2>
        <p>Spletna stran zbira naslednje podatke: Ime, geslo in razred.</p>
        <p>Pridobljeni podatki so namenjeni generaciji uporabniškega imena.</p>
        <p>
          Pridobljeno ime in razred se uporabljata za namene filtriranja vsebin
          in ustvaritve računa.
        </p>

        <p>Uporabniku je omogočen dostop do spletnega dokumenta </p>
        <p>
          Dokument v katerega oseba vpisuje svoje naloge se nahaja na računu
          posameznega učitelja.
        </p>
        <p>
          Dostop do posameznega dokumenta ima le učenec (uporabnik) in učitelj,
          ki učenca poučuje.
        </p>
        <p>
          Uporabnik se zavezuje, da povezave do svojega dokumenta ne bo delil,
          saj s tem ogroža varnost dokumenta.
        </p>
      </div>
    </div>
  );
};

export default Pogoji;
